import React, {memo, useEffect} from 'react';
import styles from "./buttons.module.sass";
import {Button} from "antd";
import {
    changeTimeValue, checkBoxesCategoriesAC,
    choiceOfPlatformAC,
    selectCategoryAC, selectChartAC,
    selectMarketPlacesCheckBoxAC,
    selectSOVAC, selectSuperMarketsCheckBoxAC, setTableAC,
    sharesCheckedAC, switchCategoriesAC
} from "../../../redux/optionsReducer";
import {SOVForMarketPlaces, SOVForSuperMarkets} from "../../../common/optionsForSwitches";
import {defValueForMarketPlaces, defValueForSuperMarkets} from "../../../common/optionsForCheckBoxes";
import {useAppDispatch, useAppSelector} from "../../../redux/store";
import {
    choiceOfPlatform,
    selectCategory,
    selectSwitchShares,
    selectSwitchSOV, selectTableContent, selectTableContentForSpm
} from "../../../common/selectors";
import {selectFilterTitleAC} from "../../../redux/tableReducer";
import {plainOptionsMps, plainOptionsSpm} from "../../../common/optionsTableShares";
import {defaultTime} from "../../../common/optionsForDate";
import {tableChartCategoriesAC} from "../../../redux/categoriesReducer";
import {loadingTablesAC} from "../../../redux/authReducer";

type ButtonsPropsType = {
    place: 'stock' | 'price' | 'news'
}
export const Buttons = memo(({place}: ButtonsPropsType) => {

    const dispatch = useAppDispatch()
    const category = useAppSelector(selectCategory)
    const switchSOV = useAppSelector(selectSwitchSOV)
    const switchShares = useAppSelector(selectSwitchShares)
    const platform = useAppSelector(choiceOfPlatform)

    const scroll = () => {
        const element = document.getElementById('table');
        setTimeout(() => element?.scrollIntoView({ block: "start" }), 2500)
    }

    const onClickPlacesHandler = () => {
        dispatch(selectCategoryAC('marketplaces'))
        dispatch(selectChartAC('Рынок, темпы'))
        switchSOV&&dispatch(selectSOVAC(SOVForMarketPlaces))
        switchShares&&dispatch(selectMarketPlacesCheckBoxAC(defValueForMarketPlaces))
        dispatch(sharesCheckedAC(defValueForMarketPlaces))
        dispatch(selectFilterTitleAC(plainOptionsMps))
        dispatch(changeTimeValue(defaultTime))
        dispatch(choiceOfPlatformAC('stocks'))
        dispatch(switchCategoriesAC(false))
        dispatch(setTableAC(false))
        dispatch(tableChartCategoriesAC(''))
        dispatch(checkBoxesCategoriesAC(false))
        {place === 'news' && scroll()}
    }

    const onClickMarketsHandler = () => {
        dispatch(selectCategoryAC('supermarkets'))
        dispatch(selectChartAC('Рынок, темпы'))
        dispatch(choiceOfPlatformAC('stocks'))
        switchSOV&&dispatch(selectSOVAC(SOVForSuperMarkets))
        switchShares&&dispatch(selectSuperMarketsCheckBoxAC(defValueForSuperMarkets))
        dispatch(sharesCheckedAC(defValueForSuperMarkets))
        dispatch(selectFilterTitleAC(plainOptionsSpm))
        dispatch(changeTimeValue(defaultTime))
        dispatch(switchCategoriesAC(false))
        dispatch(setTableAC(false))
        dispatch(tableChartCategoriesAC(''))
        dispatch(checkBoxesCategoriesAC(false))
        {place === 'news' && scroll()}
    }

    const onClickPriceIndexHandler = () => {
        dispatch(choiceOfPlatformAC('price'))
        dispatch(selectChartAC('PI фактический'))
        dispatch(selectCategoryAC(''))
        dispatch(switchCategoriesAC(false))
        dispatch(tableChartCategoriesAC(''))
        dispatch(checkBoxesCategoriesAC(false))
    }

    const onClickCategoriesHandler = () => {
        dispatch(switchCategoriesAC(true))
        dispatch(choiceOfPlatformAC('categories'))
        dispatch(selectChartAC('Категории'))
        dispatch(selectCategoryAC('marketplaces'))
        dispatch(tableChartCategoriesAC(''))
        dispatch(checkBoxesCategoriesAC(true))
        dispatch(selectMarketPlacesCheckBoxAC(defValueForMarketPlaces))
        dispatch(selectFilterTitleAC(plainOptionsMps))
    }


    return (
        <div className={styles.main}>
            <div className={styles.buttons}>
                <Button className={styles.button} onClick={onClickPlacesHandler}
                        type={platform === 'stocks' && category === 'marketplaces' ? 'default' : 'primary'}>Маркетплейсы</Button>
                <Button className={styles.button} onClick={onClickMarketsHandler}
                        type={platform === 'stocks' && category === 'supermarkets' ? 'default' : 'primary'}>Супермаркеты</Button>
            </div>
            {place !== 'news' && <div className={styles.buttons}>
                <Button className={styles.button} onClick={onClickCategoriesHandler}
                        type={platform === 'categories' ? 'default' : 'primary'}>Категории</Button>
                <Button className={styles.button} onClick={onClickPriceIndexHandler}
                        type={platform === 'price' ? 'default' : 'primary'}>Индекс цен</Button>
            </div>}

        </div>
    );
});

